import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from "react-onclickoutside";
import DropDownIcon from '../../assets/CustomDropDownIcon';
import './index.css';

const styles = {
  wrapper: {
    width: '100%',
    position: 'relative',
    cursor: 'pointer',
  },
  title: {
    padding: '15px',
    color: '#7A7A7A',
    border: '1px solid #A4ADC1',
    display: 'flex',
    borderRadius: '10px'
  },
  optionsWrapper: {
    margin: 'unset',
    padding: 'unset',
    paddingTop: '5px',
    listStyleType: 'none',
    position: 'absolute',
    backgroundColor: '#fff',
    width: '100%',
    WebkitBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
    MozBoxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
    boxShadow: '5px 5px 10px 0px rgba(24,62,153,0.13)',
  },
  option: {
    padding: '15px',
    borderBottom: '1px solid #F2F5FB',
    color: '#09183A',
    cursor: 'pointer',
  }
};

class Dropdown extends Component{
  constructor(props){
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: '',
    }
  }

  componentDidMount(){
    this.setState({
      headerTitle: this.props.defaultTitle
    })
  }

  handleClickOutside = evt => {
    this.close();
  };

  selectItem(title, item){
    this.setState({
      headerTitle: title,
      listOpen: false
    }, this.props.toggleSelected(item))
  }

  close = () => {
    this.setState({
      listOpen: false
    })
  };

  toggleList = () => {
    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }))
  };

  render() {
    const{ options } = this.props;
    const { listOpen } = this.state;
    return(
      <div style={styles.wrapper}>
        <div
          style={styles.title}
          onClick={() => this.toggleList()}
        >
          <div style={{flexGrow: '1'}}>
            {this.state.headerTitle}
          </div>
          <DropDownIcon
            isOpened={listOpen}
            width={'15px'}
            height={'20px'}
          />
        </div>
        {listOpen && <ul style={styles.optionsWrapper} onClick={e => e.stopPropagation()}>
          {options.map((item)=> (
            <li
              className='listItem'
              key={item.title}
              onClick={() => this.selectItem(item.title, item)}
              style={styles.option}
            >
              {item.title}
            </li>
          ))}
        </ul>}
      </div>
    )
  }
}

Dropdown.propTypes = {
  options: PropTypes.array,
  defaultTitle: PropTypes.string,
  toggleSelected: PropTypes.func,
};

Dropdown.defaultProps = {
  options: [{
    id: 0,
    title: 'No Options to Select',
    status: false
  }],
  defaultTitle: 'select',
  toggleSelected: () => {}
};

export default onClickOutside(Dropdown);



// WEBPACK FOOTER //
// ./src/components/select-with-borders/index.jsx